import { useState } from "react";
import { collectionCarouselCards } from "../data/content";
import styles from "./Collection.module.css";

export default function Collection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const cards = collectionCarouselCards;

  if (!cards.length) return null;

  const getCardPosition = (index) => {
    let position = index - activeIndex;

    if (position > 2) {
      position -= cards.length;
    }

    if (position < -2) {
      position += cards.length;
    }

    return position;
  };

  const goToPrevious = () => {
    setActiveIndex((current) =>
        current === 0 ? cards.length - 1 : current - 1
    );
  };

  const goToNext = () => {
    setActiveIndex((current) =>
        current === cards.length - 1 ? 0 : current + 1
    );
  };

  const handleCollectionOpen = (event, collectionId) => {
    event.preventDefault();

    window.history.pushState(
        null,
        "",
        `/colecoes/${collectionId}`
    );

    window.dispatchEvent(new PopStateEvent("popstate"));

    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  };

  return (
      <section className={styles.collection} id="collection">
        <div className={styles.title}>
          <h2>TRABALHOS</h2>

          <p className={styles.subtitle}>
           Selecione um card para ver mais detalhes sobre cada trabalho realizado.
          </p>
        </div>

        <div
            className={styles.carouselShell}
            aria-label="Carrossel de coleções"
        >
          <button
              type="button"
              className={`${styles.navButton} ${styles.navButtonPrevious}`}
              onClick={goToPrevious}
              aria-label="Card anterior"
          >
            ‹
          </button>

          <div className={styles.carouselStage}>
            {cards.map((card, index) => {
              const position = getCardPosition(index);
              const isActive = position === 0;

              return (
                 <article
    key={card.id}
    id={card.id}
    className={`${styles.carouselCard} ${
        styles[`position${position}`]
    } ${isActive ? styles.carouselCardActive : ""} ${
        card.id === "editorial-street-hype"
            ? styles.editorialStreetHype
            : ""
    }`}
    aria-hidden={!isActive && Math.abs(position) > 2}
    onClick={() => {
        if (!isActive) {
            setActiveIndex(index);
        }
    }}
>
    <div className={styles.cardImageFrame}>
        <img
            src={card.image}
            alt={card.title}
        />
    </div>

    <div className={styles.cardContent}>
        <p className={styles.cardEyebrow}>
            {card.eyebrow}
        </p>

        <h3>{card.title}</h3>

        <p>{card.description}</p>

        <p className={styles.cardDetails}>
            {card.details}
        </p>

        <a
            className={styles.expandButton}
            href={`/colecoes/${card.id}`}
            onClick={(event) =>
                handleCollectionOpen(event, card.id)
            }
        >
            Ver coleção
        </a>
    </div>
</article>
              );
            })}
          </div>

          <button
              type="button"
              className={`${styles.navButton} ${styles.navButtonNext}`}
              onClick={goToNext}
              aria-label="Próximo card"
          >
            ›
          </button>
        </div>

        <div className={styles.dots} aria-label="Selecionar card">
          {cards.map((card, index) => (
              <button
                  key={card.id}
                  type="button"
                  className={`${styles.dot} ${
                      activeIndex === index ? styles.dotActive : ""
                  }`}
                  onClick={() => setActiveIndex(index)}
                  aria-label={`Ir para ${card.title}`}
                  aria-current={activeIndex === index}
              />
          ))}
        </div>
      </section>
  );
}